/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React from 'react';
import { SvgIcon } from '@mineral/core';
import './icons.less';

const AlarmsManagement = (props) => (
  <SvgIcon {...props}>
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M8.323 22c-.227 0-.45-.058-.648-.17a1.313 1.313 0 01-.505-1.792L13.597 8.67a1.327 1.327 0 012.306 0l6.427 11.367c.112.197.17.42.17.645A1.32 1.32 0 0121.177 22H8.323zm6.456-1.815a.926.926 0 01-.928-.923c0-.51.415-.924.928-.924.512 0 .928.414.928.924s-.416.923-.928.923zm.831-8.491v4.926h-1.67v-4.926h1.67z'
      clipRule='evenodd'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M8.852 13H3V4h16v6.085l1.915 3.386A1.09 1.09 0 0021 13V4a2 2 0 00-2-2H3a2 2 0 00-2 2v9a2 2 0 002 2h4.721l1.13-2z'
      clipRule='evenodd'
      opacity='.8'
    />
  </SvgIcon>
);

export default AlarmsManagement;
